<div class="group relative">
  <label
    [attr.for]="'productSearch'"
    class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
    {{ label() }}
  </label>

  <div class="relative">
    <input
      type="text"
      [id]="'productSearch'"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange($event)"
      (focus)="inputFocus.emit()"
      class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] transition-all outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pl-10 rtl:pr-10"
      [placeholder]="placeholder()" />

    <svg
      class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 ltr:left-3 rtl:right-3"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>

    @if (showDropdown()) {
      <div
        class="absolute z-20 mt-1 max-h-52 w-full overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl">
        @if (loading()) {
          <div class="py-2">
            <app-loading />
          </div>
          <!-- <div class="px-3 py-2 text-[13px] text-gray-500" i18n="@@productNameSearching">Searching...</div> -->
        } @else if (error()) {
          <div class="px-3 py-2 text-[13px] text-red-500">
            {{ error() }}
          </div>
        } @else if (results().length === 0) {
          <div class="px-3 py-2 text-[13px] text-gray-500" i18n="@@NameNotFound">No items found.</div>
        } @else {
          <!-- @for (item of results(); track item.id) {
            <button
              (click)="onSelect(item)"
              class="block w-full px-4 py-2 text-[14px] transition-colors hover:bg-gray-50 ltr:text-left rtl:text-right">
              {{ isArabic() ? item.titleAr || item.titleEn : item.titleEn }}
            </button>
          } -->

          @for (item of results(); track item.id) {
  <button
    type="button"
    (click)="onSelect(item)"
    class="flex w-full items-center gap-3 px-4 py-2.5 text-[14px] transition-colors hover:bg-gray-50 ltr:text-left rtl:text-right"
  >
    <img
      [src]="item.image || '/assets/product.png'"
      alt="Product"
      class="h-10 w-10 shrink-0 rounded-md object-contain"
    />

    <div class="min-w-0 flex-1">
      <p class="truncate font-medium text-gray-900">
        {{ isArabic() ? item.titleAr || item.titleEn : item.titleEn || item.titleAr }}
      </p>

      <p class="truncate text-[12px] text-gray-500">
        {{ item.manufacturerCompanyName || 'Manufacturer Company' }}
      </p>
    </div>
  </button>
}
        }
      </div>
    }
  </div>
</div>
